/**
 * IMPORTS
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

// typings
import { IPayloadApi } from "@/hooks/usuarios-cliente/excluir-usuario-cliente/interface";

import type { IExcluirUsuarioClienteResponseApi } from "@/data/dtos/response-api/usuarios-cliente/excluir-usuario-cliente-response-api";
// factories - usuarios-cliente - use-case
import { makeExcluirUsuarioClienteUseCase } from "@/factories/usuarios-cliente/make-excluir-usuario-cliente-use-case";
// utils
import { getApiErrorMessage } from "@/utils/normalize-api-error/normalize-api-error";
import { notifyError, notifySuccess } from "@/utils/notify-messages";

/**
 * Hook React Query — `DELETE /usuarios-cliente/{id}`
 */
function useExcluirUsuarioCliente() {
  const queryClient = useQueryClient();

  const mutation = useMutation<IExcluirUsuarioClienteResponseApi, Error, IPayloadApi>({
    mutationFn: ({ user_id }) => makeExcluirUsuarioClienteUseCase().execute(user_id),

    onSuccess: async (response) => {
      notifySuccess(response?.message ?? "Usuário excluído com sucesso!");
      await queryClient.invalidateQueries({ queryKey: ["usuario-clientes"] });
    },

    onError: (error) => {
      notifyError(getApiErrorMessage(error));
    },
  });

  return {
    excluirUsuarioCliente: mutation.mutate,
    excluirUsuarioClienteAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
    isSuccess: mutation.isSuccess,
  };
}

/**
 * EXPORT
 */
export { useExcluirUsuarioCliente };
